window.application.register("form", 
	class extends Stimulus.Controller {

		//function custom(req, res, element){
			//req = formObject
			//res = api response
			//element = button or form that triggered submit
		//}
		// data-controller="form"
		// data-form-url="<%=baseUrl%>/api/test"
		// data-action="change->form#submit"
		// data-form-indicator="preloader or spinner"
		// data-form-fade="true or false"
        // data-form-redirect="<%=baseUrl%>/vul/plans" <-- optional to overwrite response behavior
        // data-form-submit-callback="custom" <-- optional to overwrite response behavior
		
		// <input data-target="form.input" type="email"  name="email">
		// <button data-target="form.submitBtn" data-action="form#submit" type="submit">
		// <p data-target="form.errors"></p>

		//you can also set the callback through an action. ex:
		// <input data-action="change->form#setSubmitCallback" data-form-submit-callback="newCallback">

		//you can append data to the form on click
		// data-action="form#includeData"
		// data-form-include-data='{"paymentPlanCode":"asdsadasd"}'

		//you can remove included data to the form on click
		// data-action="form#removeIncludeData"
		// data-form-include-data='{"paymentPlanCode":"asdsadasd"}'

		//you can include hidden form inputs on submit at the input level
		//<input class="hidden" type="text" data-form-include-hidden>

		//you can include hidden form inputs on submit at the form level
		//<form type="text" data-form-include-hidden>


		static get targets() {
		  return [ "input" , "submitBtn", "errors"]
		}
		connect(){
			//expose controller to element["form"]
			this.element[this.identifier] = this;
			this.element.addEventListener('change', this.updateValues.bind(this));
			this.element.addEventListener('updateView', this.updateValues.bind(this));
			this.updateValues();
		}

		updateValues(){
			var formObject = {};
			for(let index in this.inputTargets){
				var input = this.inputTargets[index];
				if(!input.closest('.hidden') || input.dataset.formIncludeHidden== "true" || this.element.dataset.formIncludeHidden == "true"){
					if(input["radio"]){
						formObject[input.name] = input["radio"].value;
					}else if(input["money"]){
						formObject[input.name] = input["money"].value;
					}else if(input["date"]){
						formObject[input.name] = input["date"].value;
					}else if(input["checkbox"]){
						formObject[input.name] = input["checkbox"].value;
					}else if(input.type == "file"){
						formObject[input.name] = input.files[0]?input.files[0]:'';
					}else if(input.type == "number"){
						formObject[input.name] = Number(input.value);
					}else if(input.type == "range"){
						formObject[input.name] = Number(input.value);
					}else{
						formObject[input.name] = input.value;
					}
				}else{
					
				}
			}
			
			var mergedData = _.merge(formObject, this.data.get('includeData')?JSON.parse(this.data.get('includeData')):{});
			this.formObject = mergedData;
		}

		submitFormData(e){
			if(e){
				this.submitElement = e.currentTarget;
				e.preventDefault();	
			}else{
				this.submitElement = null;
			}
			document.activeElement.blur();
			this.updateValues();
			if(this.data.get('fade')=='true'){
				this.element.classList.add('pointer-events-none');
				this.element.classList.add('opacity-50');	
			}			
			if(this.data.get('indicator') == 'spinner' && window.spinner){
				window.spinner.attach(this.submitBtnTarget);
			}else if(this.data.get('indicator') == 'preloader' && window.preloader){
				window.preloader.show();
			}
			if(this.hasErrorsTarget){
				this.errorsTarget.classList.add('hidden');
			}
			var formData = new FormData();
			for(let key in this.formObject){
				formData.append(key, this.formObject[key]);
			}
			if(this.data.get('bodyCsrf') == "true"){
				formData.append('_csrf', this.data.get('csrf')?this.data.get('csrf'):_csrf);	
			}
			fetch(this.data.get('url'), {
		  		method: 'POST',
		  		body: formData,
		  		headers: {'csrf-token': this.data.get('csrf')?this.data.get('csrf'):_csrf}
			})
			.then(response => response.json())
			.then(result => {
				this.handleResult(result);
			})
			.catch(error => {
				this.handleError(error)
			});
		}


		submit(e){
			if(e){
				this.submitElement = e.currentTarget;
				e.preventDefault();	
			}else{
				this.submitElement = null;
			}
			document.activeElement.blur();
			this.updateValues();
			if(this.data.get('fade')=='true'){
				this.element.classList.add('pointer-events-none');
				this.element.classList.add('opacity-50');	
			}			
			if(this.data.get('indicator') == 'spinner' && window.spinner){
				window.spinner.attach(this.submitBtnTarget);
			}else if(this.data.get('indicator') == 'preloader' && window.preloader){
				window.preloader.show();
			}
			if(this.hasErrorsTarget){
				this.errorsTarget.classList.add('hidden');
			};
			if(this.data.get('bodyCsrf') == "true"){
				this.formObject._csrf = this.data.get('csrf')?this.data.get('csrf'):_csrf;
			}
			fetch(this.data.get('url'), {
		  		method: 'POST',
		  		body: JSON.stringify(window.utils.unflatten(this.formObject)),
		  		headers: {
		  			'csrf-token': this.data.get('csrf')?this.data.get('csrf'):_csrf,
					'Content-Type': 'application/json'
    	  		}
			})
			.then(response => response.json())
			.then(result => {
				// console.log(result);
				this.handleResult(result);
			})
			.catch(error => {
				// console.log(error);
				this.handleError(error)
			});
		}

		handleError(error){
			console.log('Error:', error);
			if(this.data.get('fade')=='true'){
				this.element.classList.remove('pointer-events-none');
				this.element.classList.remove('opacity-50');
			}
			this.renderErrors([{message:'Something went wrong. Please try again later.'}])
			if(window.spinner){
				window.spinner.remove(this.submitBtnTarget);
			}else if(window.preloader){
				window.preloader.hide();
			}
		}

		handleResult(result){
			if(result.errors){
				this.renderErrors(result.errors);
				if(this.data.get('fade')=='true'){
					this.element.classList.remove('pointer-events-none');
					this.element.classList.remove('opacity-50');
				}
				if(this.data.get('indicator') == 'spinner' && window.spinner){
					window.spinner.remove(this.submitBtnTarget);
				}else if(this.data.get('indicator') == 'preloader' && window.preloader){
					window.preloader.hide();
				}
			}else{
				if(this.data.get('submitCallback')){
					window[this.data.get('submitCallback')](this.formObject, result, this.submitElement?this.submitElement:null);
					this.submitElement = null;
				}else if(this.data.get('redirect')){
					window.location.href = this.data.get('redirect');
				}else if(result.redirect){
					window.location.href = result.redirect;
				}else if(result.dialog){
					window.dialog.show(result.dialog);
					if(this.data.get('fade')=='true'){
						this.element.classList.remove('pointer-events-none');
						this.element.classList.remove('opacity-50');
					}
					if(this.data.get('indicator') == 'spinner' && window.spinner){
						window.spinner.remove(this.submitBtnTarget);
					}else if(this.data.get('indicator') == 'preloader' && window.preloader){
						window.preloader.hide();
					}
				}
			}	
		}
		
		renderErrors(errors){
			try{
				_.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
				var _template = '<span class="block text-sm">{{message}}</span>';
				var errorHtml = '';
				for(let index in errors){
					var compiled = _.template(_template);
					try{
						var errorString = '';

						if(typeof errors[index] == 'string'){
							errorString = compiled({message:errors[index]});
						}else{
							errorString = compiled({message:errors[index].message});
						}
						
						errorHtml+=errorString;
					}catch(err){
						errorHtml+='<span>Something went wrong. Please try again later.</span> <br>';
					}
				}
				if(this.hasErrorsTarget){
					this.errorsTarget.classList.remove('hidden');
					this.errorsTarget.innerHTML = errorHtml;
				}
			}catch(err){
					this.errorsTarget.innerHTML = '<span>Something went wrong. Please try again later.</span> <br>';
			}
		}
		
		setSubmitCallback(e){
			this.data.set('submitCallback', e.currentTarget.dataset.formSubmitCallback);
		}
		
		removeSubmitCallback(e){
			this.element.removeAttribute('data-form-submit-callback');
		}
		
		disconnect(){
			this.element.removeEventListener('change', this.updateValues.bind(this));
			this.element.removeEventListener('updateView', this.updateValues.bind(this));
		}

		includeData(e){
			var oldData = this.data.get('includeData')?JSON.parse(this.data.get('includeData')):{};
			var newData = _.merge(oldData, JSON.parse(e.currentTarget.dataset.formIncludeData));
			this.data.set('includeData', JSON.stringify(newData));
		}
		removeIncludeData(){
			this.element.removeAttribute('data-form-include-data')
		}

		logData(){
			this.updateValues();
			// console.log(window.utils.unflatten(this.formObject));
		}

		get value(){
			this.updateValues();
			return this.formObject;
		}
	}
)
